import React, { useEffect, useRef, useState } from 'react';
import smoothscroll from 'smoothscroll-polyfill';
import useOnLoadImages from "../../libs/hooks/useOnLoadImages";

import { getZoom, isMobileDevice, isMobileUI } from '../../constants';
import { isEs } from "../../libs/lang";

const MastheadSustainabilty = () => {
	const mastheadRef = useRef(null);
	const [mastheadHeight, setHeight] = useState(false);
	const wrapperRef = useRef(null);
	// const imagesLoaded = useOnLoadImages(mastheadRef);
	const [imagesLoaded, setImagesLoaded] = useState(false);

	useEffect(() => {
		smoothscroll.polyfill();

		let zoom = getZoom();

		function isZooming() {
			const newZoom = getZoom();
			let returnVal = false;
			if (newZoom !== zoom) {
				zoom = newZoom;
				returnVal = true;
			}
			return returnVal;
		}

		const isIE11 = () => !(window.ActiveXObject) && "ActiveXObject" in window;

		function setStickyCta() {
			if (isIE11() && !isMobileDevice() && (isMobileUI(768) || zoom >= 2)) {
				document.body.style.position = '';
				mastheadRef.current.style.marginTop = '0';
			}
		}

		if (!mastheadHeight && window.innerWidth < 768) {
			// only set the masthead height once, on page load.
			// otherwise, on mobile devices, the masthead would grow once the user scrolls and
			// the browser bar disappears
			setHeight(true);

		}

		// WCAG support - needed so that background video remains visible once mobile ui is shown on desktop
		window.addEventListener('resize', e => {
			if (isMobileUI(768) && !isMobileDevice()) {
				// document.getElementById('masthead').style.height = '100vh';
			}
		})

		window.setTimeout(() => {
			setStickyCta();
		}, 50);

		window.addEventListener('resize', () => {
			if (isZooming()) {
				setStickyCta();
			}
		});
		window.addEventListener('scroll', () => {
			setStickyCta();
		});

	}, [imagesLoaded, mastheadHeight]);

	return (
		<div id="masthead" ref={mastheadRef}>
			<div className="bg-img" role="img"



				aria-label={`${isEs() ? 'es' : 'Young girl runs through park with urban building in the background.'}`}



				alt="Young girl runs through park with urban building in the background."/>

			{/*{imagesLoaded && (<div className="gradient"/>)}*/}

			<div className="masthead-text">
				<div className="logo-img--isf" role="img" aria-label="Institute for Sustainable Finance logo." alt="Institute for Sustainable Finance logo."/>
				<div className="heading">
					<h1 id="sustainability-main-h1" tabIndex="-1">Financing a&nbsp;more sustainable future</h1>
				</div>
			</div>
		</div>
	)
}

export default MastheadSustainabilty;
